module.exports = __webpack_public_path__ + "static/p-efc474b5e7b26a11222de1873c119778.jpg";